import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import TestSearch from '../TestSearch';
import TestTable from '../TestTable';

/**
 * "Tests" tab of the collection page: its header counts the `tests` of the collection, then the search that adds
 * one (see TestSearch, fed by `onSearch` and `onAdd`) and the table of the tests (see TestTable, fed by `onRemove`
 * and `pendingReferences`). `languagesOptions` are the catalogue languages (their id labelled by their code). Once
 * the last test is removed, the focus moves to the search field.
 */
const TestsTab = ({ tests = [], languagesOptions = [], onSearch, onAdd, onRemove, pendingReferences = [] }) => {
    const { t } = useTranslation('bo');
    const searchRef = useRef(null);

    return (
        <FlexBox flexDirection="column" gap="s">
            <Typography seo={2} fontSize="l" fontWeight="bold" color="neutral-primary">
                {t('Tests ({{total}})', { total: tests.length })}
            </Typography>
            <TestSearch ref={searchRef} collectionTests={tests} languagesOptions={languagesOptions} onSearch={onSearch} onAdd={onAdd} />
            <TestTable
                tests={tests}
                languagesOptions={languagesOptions}
                onRemove={onRemove}
                onEmptied={() => searchRef.current?.focus()}
                pendingReferences={pendingReferences}
            />
        </FlexBox>
    );
};

export default TestsTab;
